module.exports = __webpack_public_path__ + "media/categories/1008-edcd8373.svg";